class AlternativeLayout {
    constructor() {
        this.urlParams = new URLSearchParams(window.location.search);
        this.isAlternativeLayout = this.urlParams.get('lpl') === 'on';

        if (!this.isAlternativeLayout) return;

        AlternativeLayout.addLinkGetParam();
    }

    static addLinkGetParam() {
        const links = document.querySelectorAll('a[href]');
        const { origin } = window.location;

        links.forEach((link) => {
            const href = link.getAttribute('href');
            if (href.includes(`${origin}/event-`)) {
                const url = new URL(href);
                url.searchParams.set('lpl', 'on');
                link.href = url.toString(); // eslint-disable-line
            }
        });
    }
}

export default AlternativeLayout;
